import React, { useEffect, useState } from "react";
import { QuestionHead, QuestionHeader } from "../styled/styles";
import styled from "styled-components";
const StyledDiv = styled.div`
  display: ${(props) => (props.toDisplay ? "block" : "none")};
  width: 85%;
  margin-left: 2.6em;
  margin-bottom: 4.8em;
  margin-top: 1.8em;
  @media (max-width: 500px) {
    margin-left: 2em;
  }
  @media (max-width: 480px) {
    margin-left: 1.6em;
  }
`;

const SliderContainer = styled.div`
  position: relative;
  margin: 20px 0;
  width: 100%;
`;

const SliderTrack = styled.div`
  width: 100%;
  height: 4px;
  background-color: #ccc;
`;

const SliderHandle = styled.div`
  position: absolute;
  border: solid 1px #959595;
  width: 30px;
  height: 30px;
  background-color: #fff;
  top: -12px;
  left: ${(props) => (props.sliderMoved ? props.position : 0)}%;
  transform: translateX(-50%);
  border-radius: 50%;
  cursor: pointer;
  pointer-events: none;
`;

const Label = styled.div`
  position: absolute;
  top: 30px;
  left: ${(props) => props.position}%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #555;
  font-weight: 700;
  ${(props) => props.edges && "width: 4em;"};
`;

const TickMark = styled.div`
  position: absolute;
  top: 1em;
  left: ${(props) => props.position}%;
  transform: translateX(-50%);
  width: 1px;
  height: 10px;
  background-color: #000;
  font-weight: 100;
`;

const Slider = ({
  toDisplay,
  currentPage,
  errors,
  setErrors,
  answeredQuestions,
  setAnsweredQuestions,
  currentPageAnswers,
  setCurrentPageAnswers,
  questionsArray,
  question,
}) => {
  const [sliderValue, setSliderValue] = useState("0");
  const [sliderMoved, setSliderMoved] = useState(false);
     
  useEffect(() => {
    if (currentPageAnswers.length && currentPageAnswers) {
      let answeredQuestionsCopy = [...answeredQuestions];
      if (
        currentPageAnswers.find((pageAnswer) =>
          pageAnswer.includes(question.Answers[0].AnswerCode)
        )
      ) {
        let value = `${Number.parseInt(
          currentPageAnswers
            .find((answer) => answer.includes(questionsArray[0].AnswerCode))
            ?.split("=")[1]
        )}`
         
        setSliderValue((value === 'NaN' || value === 'null') ? '0' : value);
      } else {
        answeredQuestionsCopy[currentPage - 1] = [
          ...currentPageAnswers,
          `${question.Answers[0].AnswerCode}=0`,
        ];
         
        setCurrentPageAnswers([
          ...currentPageAnswers,
          `${question.Answers[0].AnswerCode}=0`,
        ]);
         
        setAnsweredQuestions(answeredQuestionsCopy);
         
        setSliderValue("0");
      }
    };
  }, [toDisplay, JSON.stringify(currentPageAnswers.filter(ans => ans.includes(question.Answers[0].AnswerCode)))]);

  useEffect(() => {
    let previousSliderAnswer = currentPageAnswers
      .find((answer) => answer.includes(questionsArray[0].AnswerCode))
      ?.split("=")[1];
    if (currentPageAnswers.length && previousSliderAnswer) {
        
      let value = `${Number.parseInt(previousSliderAnswer) - 1}`
       
      setSliderValue((value === 'NaN' || value === 'null') ? '0' : value);
    }
  }, [currentPageAnswers]);

  const handleSliderChange = (event) => {
     
    setSliderMoved(true);
    // 
    window.sliderMoved = true;
    let newValue = `${event.target.dataset.code}=${
      Number.parseInt(event.currentTarget.value) + 1
    }`;

    let answeredQuestionsCopy = [...answeredQuestions];

    let answeredCurrentQuestion = answeredQuestionsCopy[currentPage - 1].filter(answer => typeof answer === 'string' && answer.includes(question.Answers[0].AnswerCode))[0]

    answeredQuestionsCopy[currentPage - 1] = [
      ...answeredQuestionsCopy[currentPage - 1]?.filter(
        (answer) => answer !== answeredCurrentQuestion
      ),
      newValue,
    ];
     
    setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
      
    setAnsweredQuestions([...answeredQuestionsCopy]);
     
    setSliderValue(event.target.value === 'NaN' || event.target.value === 'null' ? '0' : event.target.value);

    setErrors(
      errors.filter(
        (errorExpression) => errorExpression !== question.QuestionCode
      )
    );
  };

  return (
    <SliderContainer>
      <SliderTrack>
        <input
          type="range"
          min="0"
          max={questionsArray.length - 1}
          value={sliderValue}
          data-code={questionsArray[0].AnswerCode}
          onChange={(e) => {
             
            handleSliderChange(e);
          }}
          style={{
            width: "100%",
            position: "relative",
            width: "101%",
            top: "-6px",
            left: "-3px",
          }}
        />
        {questionsArray.map((answer, index) => (
          <>
            <TickMark
              key={`tick-${index}`}
              position={(index / (questionsArray.length - 1)) * 100}
            />
            <Label
              edges={index === 0 || index === questionsArray.length - 1}
              key={index}
              position={(index / (questionsArray.length - 1)) * 100}
            >
              {answer.AnswerLabel}
            </Label>
          </>
        ))}
        <SliderHandle
          sliderMoved={sliderMoved}
          position={(sliderValue / (questionsArray.length - 1)) * 100}
        />
      </SliderTrack>
    </SliderContainer>
  );
};

const Slide = ({
  currentPage,
  errors,
  setErrors,
  toDisplay,
  question,
  answeredQuestions,
  setAnsweredQuestions,
  currentPageAnswers,
  setCurrentPageAnswers,
  parseDynamicQuestionText
}) => {
  return (
    <>
      <QuestionHead padding="0 15px">{parseDynamicQuestionText(question.QuestionHead)}</QuestionHead>
      <QuestionHeader
        padding="0 15px"
        errors={errors}
        setErrors={setErrors}
        question={question}
      >
        {parseDynamicQuestionText(question.QuestionName)}
      </QuestionHeader>
      <StyledDiv toDisplay={toDisplay}>
        <Slider
          toDisplay={toDisplay}
          currentPage={currentPage}
          setCurrentPageAnswers={setCurrentPageAnswers}
          currentPageAnswers={currentPageAnswers}
          question={question}
          errors={errors}
          setErrors={setErrors}
          answeredQuestions={answeredQuestions}
          setAnsweredQuestions={setAnsweredQuestions}
          questionsArray={question.Answers}
        />
      </StyledDiv>
    </>
  );
};

export default Slide;
